export const Waiting = 'Please wait...';
export const WaitingDoc = 'Waiting for document to retrieve...';
export const APIError = 'Sorry something went wrong, please try again later';
export const loginErrorTitle = 'Please check the details you entered';
export const loginErrorMessage = 'Some of the information you entered does not match our records. Please enter the email address you shared with us when you joined the RAC. Please also check you have entered all the details exactly as they appear on your membership card or documents.';
